"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const TIMEOUT_MS = 3000;
class MarkAsReadTracker {
    constructor() {
        this.events = new Map();
    }
    static getInstance() {
        if (!MarkAsReadTracker.instance) {
            MarkAsReadTracker.instance = new MarkAsReadTracker();
        }
        return MarkAsReadTracker.instance;
    }
    expect(chatId, messageId) {
        const events = this.getOrCreateEvents(chatId);
        const hasPendingTimeout = events.some(e => e.eventType === "MARK_AS_READ" &&
            e.messageId === messageId &&
            e.timeoutId !== undefined);
        // Only start a timeout if one isn't already running for this messageId
        const timeoutId = hasPendingTimeout
            ? undefined
            : setTimeout(() => this.onTimeout(chatId, messageId), TIMEOUT_MS);
        events.push({
            eventType: "MARK_AS_READ",
            messageId,
            timestamp: new Date().toISOString(),
            timeoutId,
        });
    }
    received(chatId, messageId) {
        const events = this.getOrCreateEvents(chatId);
        let lastIndex = -1;
        for (let i = events.length - 1; i >= 0; i--) {
            if (events[i].eventType === "MARK_AS_READ" &&
                events[i].messageId === messageId) {
                lastIndex = i;
                break;
            }
        }
        if (lastIndex === -1) {
            return;
        }
        events.push({
            eventType: "CHAT_LOG_UPDATE",
            messageId,
            timestamp: new Date().toISOString(),
        });
        for (let i = 0; i <= lastIndex; i++) {
            const event = events[i];
            if (event.eventType === "MARK_AS_READ" && event.timeoutId !== undefined) {
                clearTimeout(event.timeoutId);
                event.timeoutId = undefined;
            }
        }
        if (!this.hasPending(events)) {
            this.cleanup(chatId);
        }
    }
    onTimeout(chatId, messageId) {
        const events = this.events.get(chatId);
        if (!events)
            return;
        for (const event of events) {
            if (event.eventType === "MARK_AS_READ" && event.messageId === messageId) {
                event.timeoutId = undefined;
            }
        }
        this.warn(`no chatlogupdate received within ${TIMEOUT_MS}s`, chatId, messageId, events);
        if (!this.hasPending(events)) {
            this.cleanup(chatId);
        }
    }
    hasPending(events) {
        return events.some(e => e.eventType === "MARK_AS_READ" && e.timeoutId !== undefined);
    }
    warn(message, chatId, messageId, events) {
        const printable = events.map(e => ({
            eventType: e.eventType,
            messageId: e.messageId,
            timestamp: e.timestamp,
        }));
        console.error(`[MarkAsReadTracker] ERROR: ${message}\n` +
            `  chatId: ${chatId}\n` +
            `  messageId: ${messageId}\n` +
            `  events: ${JSON.stringify(printable, null, 4)}`);
    }
    getOrCreateEvents(chatId) {
        if (!this.events.has(chatId)) {
            this.events.set(chatId, []);
        }
        return this.events.get(chatId);
    }
    cleanup(chatId) {
        const events = this.events.get(chatId);
        if (events) {
            events.forEach(event => {
                if (event.timeoutId !== undefined) {
                    clearTimeout(event.timeoutId);
                    event.timeoutId = undefined;
                }
            });
        }
        this.events.delete(chatId);
    }
}
exports.default = MarkAsReadTracker;
